import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import Account from 'modules/Account';
import GlucoseSettings from '../../GlucoseSettings';
import KpiSettings from '../../KpiSettings';
import messages from '../../../messages';
import styles from './PhiSettings.pcss';
const UnlockBtn = ()=>{
    const hasElevatedPermissions = useSelector(Account.selectors.hasElevatedPermissions);
    const claims = hasElevatedPermissions ? null : Account.constants.ADDITIONAL_CLAIMS.clinicSettings;
    const onSetElevatedPermissionsMode = useAction(Account.actions.setElevatedPermissionsMode, claims);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.unlockBtnContainer,
        children: /*#__PURE__*/ _jsx(Button, {
            styleModifier: hasElevatedPermissions ? 'quaternary' : 'primary',
            className: hasElevatedPermissions ? '' : 'btn--filled',
            labelMessage: messages.buttons[hasElevatedPermissions ? 'lockEditing' : 'unlockEditing'],
            onClick: onSetElevatedPermissionsMode
        })
    });
};
const PhiSettings = ()=>{
    const activeClinicMembership = useSelector(Account.selectors.activeClinicMembership);
    const { clinicId } = activeClinicMembership;
    useStyles(styles);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(UnlockBtn, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: "row",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-6 pr-10",
                        children: /*#__PURE__*/ _jsx(KpiSettings, {
                            clinicId: clinicId
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-6 pl-10",
                        children: /*#__PURE__*/ _jsx(GlucoseSettings, {
                            clinicId: clinicId
                        })
                    })
                ]
            })
        ]
    });
};
export default PhiSettings;
